// extracted by mini-css-extract-plugin
export default {"cls1":"PayoutsTableComponents-OnBehalfOfIcon_cls1__MXInB","cls2":"PayoutsTableComponents-OnBehalfOfIcon_cls2__7HK84 PayoutsTableComponents-OnBehalfOfIcon_cls1__MXInB"};